var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container cardProcessos" }, [
    _c("div", { staticClass: "content-processos" }, [
      _c("div", { staticClass: "processos-main" }, [
        _c(
          "div",
          { staticClass: "busca-processos" },
          [
            _c("search-processos", {
              on: {
                search: _vm.search,
                input: _vm.simpleSearchAsync,
                advancedInput: _vm.advancedSearchAsync,
                advancedSearch: _vm.advancedSearch,
                clear: _vm.clear
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "listagem-processos" },
          [
            _c(
              "listagem-processos",
              {
                attrs: {
                  titulo: "Processos existentes",
                  loading: _vm.loading,
                  isBusca: _vm.isBusca,
                  processos: _vm.processos
                },
                on: {
                  carregaProcessos: _vm.carregaProcessos,
                  sort: _vm.sort,
                  goTo: _vm.goTo
                }
              },
              [
                _c("app-paginacao", {
                  attrs: {
                    total: _vm.totalProcessos,
                    pagina: _vm.filtro.pagina
                  },
                  on: { changePage: _vm.changePage }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a14c1e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a14c1e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/processos/Processos.vue
// module id = null
// module chunks = 